/* eslint-disable @typescript-eslint/no-var-requires */
import { createStore, Reducer, Store } from '@reduxjs/toolkit';
import { Persistor } from 'redux-persist';
import thunkMiddleware from 'redux-thunk';
import { PERSISTED_REDUCERS } from './redux-persist.constants';

import { setPersistedDataLoaded } from './redux-persist.slice';
import { bindDevToolsIfNeeded } from './store-enhancers';

interface PersistedStore extends Store {
  __persistor?: Persistor;
}

/**
 * Creates a store with persistence
 * @returns the store created
 */
export const createPersistedStore = (reducer: Reducer): PersistedStore => {
  const { persistStore, persistReducer } = require('redux-persist');
  const storage = require('redux-persist/lib/storage').default;
  const persistConfig = {
    key: 'cir',
    // only the following reducers will be persisted.
    whitelist: PERSISTED_REDUCERS,
    storage,
  };
  const persistedReducers = persistReducer(persistConfig, reducer);
  const store: PersistedStore = createStore(persistedReducers, bindDevToolsIfNeeded([thunkMiddleware]));

  // We store the persisted object to .__persistor, so it can be available in app.ts
  // (nasty hack) @see https://github.com/kirill-konshin/next-redux-wrapper#usage-with-redux-persist
  store.__persistor = persistStore(store, null, () => store.dispatch(setPersistedDataLoaded()));

  return store;
};
